export { preloadEmbedData } from '../src/preloadEmbedData.ts';
